<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>{{$t('qualitycheck.test.tests')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <QualityCheckTestForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import QualityCheckTestForm from '../../components/qualitychecktest/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'QualityCheckTest';

const { mapFields } = createHelpers({
  getterType: 'qualitychecktest/getField',
  mutationType: 'qualitychecktest/updateField'
});

export default {
  name: 'QualityCheckTestCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    QualityCheckTestForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('qualitychecktest', ['create', 'reset'])
  }
};
</script>
